import { Capacitor } from '@capacitor/core';
import { DeviceInformation } from '../../../capacitor_plugins/deviceInformation';
import { CAPACITOR_DEVICE_INFORMATION_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import globalLogger from '../../logger';
import { isPlatformAndroid } from '../../platform/utils/platformDetailsUtils';
import platformSingleton from '../../platform/platformSingleton';
import { convertCssPtToPx, toCssPt } from '../../utils/cssUtil';

const logger = globalLogger.createChannel('mobile.navigationBarHeight');

const GESTURE_NAVIGATION_PADDING_BOTTOM_PT = 20;
let toolbarNavigationPaddingBottom = 0;

/**
 * Shares the navigation spacing used by toolbar CSS with keyboard scroll calculations.
 */
export const getToolbarNavigationPaddingBottom = (): number => toolbarNavigationPaddingBottom;

/**
 * Keeps rendered gesture spacing and numeric scroll geometry aligned.
 */
const updateGestureNavigationValues = (isGesture: boolean) => {
    const gestureNavigationPaddingBottomPt = isGesture ? GESTURE_NAVIGATION_PADDING_BOTTOM_PT : 0;
    toolbarNavigationPaddingBottom = convertCssPtToPx(gestureNavigationPaddingBottomPt);
    document.body.style.setProperty('--android-gesture-nav-padding-bottom', toCssPt(gestureNavigationPaddingBottomPt));
    document.body.classList.toggle('android-gesture-nav', isGesture);
};

/**
 * Adds the navigation bar height to the root element
 * This is used to create a bar under **Androids** navigation buttons when in 'light' mode
 * to prevent the buttons from being washed out but the bottom toolbar.
 */
export const addNavigationBarValues = async () => {
    if (!isPlatformAndroid(platformSingleton)) return;
    if (!Capacitor.isPluginAvailable(CAPACITOR_DEVICE_INFORMATION_PLUGIN)) {
        // As it's hard to detect the navigation mode from a browser, default to gesture nav behaviour
        updateGestureNavigationValues(true);
        return;
    }

    try {
        const { mode, height = 0 } = await DeviceInformation.getNavBarInfo();
        const isGesture = mode === 'gesture' || height === 0;
        updateGestureNavigationValues(isGesture);
        document.body.style.setProperty('--nav-bar-height', `${height}px`);
    } catch (error) {
        logger.error('Failed to add navigation bar values', error);
    }
};
